<template>
  <v-container fluid>
    <ContentHeader
      header-icon="mdi-progress-clock"
      header-title="Jobs"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <PtSheet>
      <div class="text-right mb-4">
        <v-btn color="primary" @click="jobParametersDialogOpen = true">
          Run Eligibility Audit
        </v-btn>
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="dataTableLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.startTime="{ item }">
          {{ item.startTime | formatDate("MM/dd/yyyy HH:mm:ss a") }}
        </template>
        <template v-slot:item.endTime="{ item }">
          {{ item.endTime | formatDate("MM/dd/yyyy HH:mm:ss a") }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="actions d-flex float-right">
            <v-btn
              depressed
              color="primary"
              :to="'jobs/eligibility/' + item.jobId"
            >
              View
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </PtSheet>

    <v-dialog v-model="jobParametersDialogOpen" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Job Parameters</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Client ID"
            required
            outlined
            dense
            v-model="clientId"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            outlined
            @click="jobParametersDialogOpen = false"
          >
            Close
          </v-btn>
          <v-btn color="primary" @click="runEligibilityAudit()">
            <v-progress-circular
              v-if="this.startingJob"
              size="22"
              width="3"
              indeterminate
            ></v-progress-circular>
            <span v-else>Start Job</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContentHeader from "@/views/ContentHeader.vue";
import { get, post } from "@/services/request";
import { eligibilityAuditAPI, trackedJobsAPI } from "@/services/api";
import { formatDate } from "@/services/format";
import PtSheet from "@/components/PtSheet.vue";

export default {
  name: "Jobs",
  components: { PtSheet, ContentHeader },
  data() {
    return {
      headers: [
        { text: "Job Type", value: "jobType" },
        { text: "Job Id", value: "jobId" },
        { text: "Description", value: "description" },
        { text: "Outcome", value: "outcome" },
        { text: "Status", value: "status" },
        { text: "Total Work", value: "totalWork" },
        { text: "Work Completed", value: "workCompleted" },
        { text: "Client Id", value: "clientId" },
        { text: "Start Time", value: "startTime" },
        { text: "End Time", value: "endTime" },
        { text: "", value: "actions", align: "end", sortable: false }
      ],
      items: [],
      dataTableLoading: true,
      jobParametersDialogOpen: false,
      clientId: null,
      startingJob: false
    };
  },
  created() {
    this.loadTableData();
  },
  filters: {
    formatDate
  },
  methods: {
    loadTableData() {
      this.dataTableLoading = true;
      get(trackedJobsAPI).then(response => {
        if (response && response.data) {
          this.items = response.data.content;
        }
        this.dataTableLoading = false;
      });
    },
    runEligibilityAudit() {
      this.startingJob = true;
      post(eligibilityAuditAPI, null, { clientId: this.clientId })
        .then(() => this.loadTableData())
        .catch(() => {
          this.showMessage({
            text: "Error starting job.",
            mode: "error"
          });
          return Promise.reject("Failed to save");
        })
        .finally(() => {
          this.jobParametersDialogOpen = false;
          this.startingJob = false;
        });
    }
  }
};
</script>

<style lang="scss">
#app #jobs .container {
  font-size: 1.5em !important;
}
</style>
